import { logProgramChange } from '@shoflo/studio-redux/utils';
import { setSceneLayout } from 'actions/Broadcast/program';
import { sceneBuilder, selectSceneLayout } from '@studio/program';
import {
  getBroadcastSourcesFromLayers,
  isAudioSource,
  isScreenSharePresenter
} from '../utils';
import setProgram from '../program/setProgram';
import updateSource from './updateSource';
import { attachAudioPresenterSources } from 'utils/broadcastSourceHelper';

export default function toggleSourceHidden(source) {
  return (dispatch, getState) => {
    const {
      program,
      banners,
      attendeeMuteStatus,
      sceneLayout,
      sceneLayers,
      broadcastSources,
      brandingSettings
    } = getState();

    const { layers = [] } = program || {};
    const changes = { hidden: !source.hidden };
    const [layerSource] = layers.filter(
      layer => layer.source._id === source._id
    );

    const combinedLayers = [...sceneLayers, ...banners];
    const sources = getBroadcastSourcesFromLayers(
      layers,
      broadcastSources.sources
    );

    if (isScreenSharePresenter(source) && source.hidden) {
      const getAllShownScreenPresentersSources =
        broadcastSources.sources.filter(screenShareSource => {
          return (
            isScreenSharePresenter(screenShareSource) &&
            !screenShareSource.hidden &&
            source._id !== screenShareSource._id
          );
        });

      getAllShownScreenPresentersSources.map(({ _id }) =>
        dispatch(
          updateSource(_id, {
            hidden: true
          })
        )
      );
    }

    const newSceneLayout = isAudioSource(source)
      ? sceneLayout
      : selectSceneLayout(sceneLayout, source, sources);
    // update the source
    dispatch(updateSource(source._id, changes));
    // If layer source is hidden - check and remove from program
    if (!!layerSource && changes.hidden) {
      const newSources = sources.filter(
        source => source._id !== layerSource.source._id
      );

      const withAudioPresenterSources = attachAudioPresenterSources(
        newSources,
        attendeeMuteStatus
      );
      const scene = sceneBuilder(
        newSceneLayout,
        withAudioPresenterSources,
        combinedLayers,
        {},
        {},
        brandingSettings?.fonts
      );
      dispatch(setProgram(scene));
      logProgramChange(getState, 'toggleSourceHidden action');
      dispatch(setSceneLayout(newSceneLayout));
    }
  };
}
